import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  Output,
  PLATFORM_ID,
} from '@angular/core';
import { TimezoneDisplayComponent } from '../../../../../../Shared/components/timezone-display/timezone-display.component';
import { LanguageSwitcherComponent } from '../../../../../../Shared/components/language-switcher/language-switcher.component';
import { isPlatformBrowser } from '@angular/common';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { SellerAuthService } from 'src/app/app-modules/seller/seller-core/_services/auth/auth.service';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TranslateModule } from '@ngx-translate/core';
import { LocaleLinkPipe } from 'src/app/Shared/_pipes/locale-link/locale-link.pipe';

@Component({
    selector: 'app-top-header',
        standalone: true,
imports: [
    TimezoneDisplayComponent,
    LanguageSwitcherComponent,
    RouterLink,
    TranslateModule,
    TranslatePipe,
    LocaleLinkPipe
],
    templateUrl: './top-header.component.html',
    styleUrl: './top-header.component.scss'
})
export class TopHeaderComponent {
  @Input() isLoggedIn!: boolean;
  @Input() isSellerLoggedIn!: boolean;
  @Input() isBuyer!: boolean;
  @Output() signOut = new EventEmitter<any>();

  horseOwnerPortalUrl = environment.horseOwnerPortalUrl;
  isDev: boolean = environment.isDev;

  handleSignOut() {
    this.signOut.emit();
  }
}
